<template>
  <div id="editar-documento-expediente">
    <v-file-input
        v-show="false"
        show-size
        label="Seleccionar Archivo PFD"
        type="file"
        ref="anexoDocumento"
        name="anexo"
        id="anexo"
        accept=".pdf"
        @change="seleccion"
      >
    </v-file-input>
    <v-form ref="editarDocumentoExpediente" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar Documento de Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title>
          <span>
            {{expedienteDocumentoEditar.documento.descripcion}}
            {{expedienteDocumentoEditar.referencia ? '-' : ''}}
            {{expedienteDocumentoEditar.referencia}}
          </span>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" md="7" class="grey lighten-3" style="height:400px">
              <template
              v-if="rutaArchivo">
              <VistaPreviaPdf
                :rutaArchivo="this.rutaArchivo" />
              </template>
              <template
                v-else>
                  <v-row justify="center" align="center" style="height:100%">
                    <custom-button
                    tipo="agregar"
                    label="Cargar Archivo"
                    iconText="fa-file-pdf"
                    @click="seleccionarArchivo">
                      <v-icon left>
                        fa-file-pdf
                      </v-icon>
                    </custom-button>
                  </v-row>
              </template>
            </v-col>
            <v-col cols="12" md="5">
              <v-row
              v-if="rutaArchivo"
              class="mx-4"
              justify="space-between"
              align="center">
                <span v-if="nombreArchivoSeleccionado">{{nombreArchivoSeleccionado}}</span>
                <custom-button
                  tipo="formCancelar"
                  label="Cambiar"
                  @click="seleccionarArchivo">
                </custom-button>
              </v-row>
              <custom-text-field
                v-model="expediente.referencia"
                label="Referencia"
                required>
              </custom-text-field>
              <custom-text-area
                v-model="expediente.observaciones"
                label="Observaciones"
                required>
              </custom-text-area>
              <template v-if="progreso">
                <v-row class="mx-4 mt-2" justify="center" align="center">
                  <span>Subiendo PDF</span>
                  <v-progress-linear
                    height="25"
                    :value="progreso"
                    color="blue darken-1"
                    dark
                  >
                    <h3>{{ progreso }}</h3>
                  </v-progress-linear>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!esformularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import mixExpedientes from '../mixExpedientes';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import VistaPreviaPdf from '@/components/VistaPreviaPdf.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'EditarDocumentoExpediente',
  mixins: [mixExpedientes, mixSubirArchivo, mixDescargarArchivo],
  props: {
    expedienteDocumentoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
    CustomTextArea,
    VistaPreviaPdf,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      rutaArchivo: null,
      nombreArchivoSeleccionado: null,
      progreso: null,
      expediente: {
        idDocumento: this.expedienteDocumentoEditar.idDocumento,
        idObra: this.expedienteDocumentoEditar.idObra,
        idLicitacion: this.expedienteDocumentoEditar.idLicitacion,
        idAdjudicacionDirecta: this.expedienteDocumentoEditar.idAdjudicacionDirecta,
        idContrato: this.expedienteDocumentoEditar.idContrato,
        publicKey: this.expedienteDocumentoEditar.publicKey, // id publico del documento subido
        referencia: this.expedienteDocumentoEditar.referencia,
        orden: this.expedienteDocumentoEditar.orden,
        existe: this.expedienteDocumentoEditar.existe,
        aplica: this.expedienteDocumentoEditar.aplica,
        observaciones: this.expedienteDocumentoEditar.observaciones,
      },
    };
  },
  methods: {
    async guardar() {
      this.enviandoFormulario = true;
      if (this.rutaArchivo && this.nombreArchivoSeleccionado) {
        const datosArchivo = this.setDatosArchivo();
        await this.mixSubirArchivo(datosArchivo);
      }
      await this.mixActualizarExpediente();
    },
    setDatosArchivo() {
      const datos = {
        nombre: `${this.expedienteDocumentoEditar.contrato.numero}_${this.mixSetEtapa(this.expedienteDocumentoEditar.documento.etapa)}_${this.expedienteDocumentoEditar.documento.descripcion}${this.expediente.referencia ? '_' : ''}${this.expediente.referencia ? this.expediente.referencia : ''}`,
        path: `${this.expedienteDocumentoEditar.contrato.ejercicio}/${this.expedienteDocumentoEditar.contrato.numero}`,
      };
      return datos;
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarDocumentoExpediente.reset();
    },
  },
  computed: {
  },
  mounted() {
    this.mixGetPdf(this.expedienteDocumentoEditar);
    eventBus.$on('seCargoArchivo', (archivoPdf) => {
      this.expediente.publicKey = archivoPdf.data.public_key;
      this.expediente.existe = true;
      this.expediente.aplica = true;
    });
  },

};
</script>

<style>

</style>
